import Photoshop from "../Images/Photoshop.png";
import Illustrator from "../Images/Illustration.png";
import Coreldraw from "../Images/Coreldraw.png";
import Sketch from "../Images/Sketch.png";
import Figma from "../Images/Figma.png";
import XD from "../Images/xd.png";
import Invision from "../Images/Invision.png";
import Aftereffect from "../Images/Aftereffects.png";
import Premier from "../Images/Premier.png";
import  Protoio from "../Images/Protoio.png";
import Framer from "../Images/Framer.png";
import Zepline from "../Images/Zepline.png";
import Anima from "../Images/Anima.png";
import Venzo from "../Images/Venzo_Logo.svg";
import Icanio from "../Images/Icanio_Logo.svg";
import Arrow from "../Images/Rightarrow.svg";
import Linkedincontact from "../Images/Contact_LinkedIn.svg";
import Dribbblecontact from "../Images/Contact_Dribbble.svg";
import Instagramcontact from "../Images/Contact_Instagram.svg";
import Mail from "../Images/Mail_Icon.svg";
import Phone from "../Images/Phone_Icon.svg";
import Line from "../Images/Line.svg";
import Slideline from "../Images/Slide_Line.svg";


const Images={
    Photoshop,
    Illustrator,
    Coreldraw,
    Sketch,
    Figma,
    XD,
    Invision,
    Aftereffect,
    Premier,
    Protoio,
    Framer,
    Zepline,
    Anima,
    Venzo,
    Icanio,
    Arrow,
    Linkedincontact,
    Dribbblecontact,
    Instagramcontact,
    Mail,
    Phone,
    Line,
    Slideline,
}

export {Images};